export const FEATURE_FLAGS = {
  manageInvoicesCreditMemosEnabled: 'manageInvoicesCreditMemosEnabled',
} as const;